import FBtnMDP from "@/components/FBtnMDP";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FPhoneFieldMDP from "@/components/form/field/FPhoneFieldMDP";


export default class CreditReportFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  parent: any;
  constructor({ parent }: { parent: any }) {
    super({ myRefName: "fromAndToDateRef" });
    this.parent = parent;
    this.addField(
      new FPhoneFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "mobile",
        label: "Mobile",
      }),
    ).addAction(
      new FBtnMDP({
        label: "Credit Report",
        onClick: this.getClientReport(),
      }),
    );
  }
  getClientReport() {
    return () => {
      this.parent.getCreditReportHtml();
    };
  }
}
